import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function GewerbeApprovals() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/gewerbe-approvals").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const handle = async (gid, freigegeben, grund = null) => {
    await api.post(`/admin/gewerbe-approvals/${gid}`, { freigegeben, ablehnungsgrund: grund });
    load();
  };

  return (
    <div className="space-y-5" data-testid="gewerbe-approvals-page">
      <h1 className="text-3xl font-heading font-bold text-falke-blue">Gewerbe-Anträge prüfen</h1>
      {items.length === 0 ? (
        <div className="falke-card p-10 text-center text-falke-anthracite/60">Keine offenen Anträge.</div>
      ) : (
        <div className="space-y-3">
          {items.map((g) => (
            <div key={g.id} className="falke-card p-5" data-testid={`gewerbe-${g.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="flex-1">
                  <div className="font-heading text-lg text-falke-blue">{g.firmenname}</div>
                  <div className="text-sm text-falke-anthracite/70">{g.user_name} · {g.user_email}</div>
                  <div className="text-sm mt-2 space-y-0.5">
                    <div>Adresse: {g.firmenadresse}</div>
                    <div>Steuernr.: {g.steuernummer} {g.ust_id_nr && `· USt-IdNr: ${g.ust_id_nr}`}</div>
                    <div>{g.kleinunternehmer ? "Kleinunternehmer (§19 UStG)" : "Regelbesteuerung"}</div>
                    <div>IBAN: {g.iban} · BIC: {g.bic}</div>
                    <div>Kontoinhaber: {g.kontoinhaber}</div>
                    {g.gewerbeschein_url && (
                      <div className="mt-2">
                        <a href={`${process.env.REACT_APP_BACKEND_URL}/api/files/${g.gewerbeschein_url}`} target="_blank" rel="noreferrer" className="text-falke-orange font-semibold hover:underline" data-testid={`gewerbeschein-link-${g.id}`}>
                          📄 Gewerbeschein ansehen ({g.gewerbeschein_filename || "Dokument"})
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <button onClick={() => handle(g.id, true)} className="btn-primary" data-testid={`gewerbe-approve-${g.id}`}>Freigeben</button>
                  <button onClick={() => {
                    const grund = prompt("Ablehnungsgrund?");
                    if (grund !== null) handle(g.id, false, grund);
                  }} className="btn-outline" data-testid={`gewerbe-reject-${g.id}`}>Ablehnen</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
